import { fetchUtil } from "@/libs/fetch";
import { filterKeyForApi, NEXT_PUBLIC_MAGENTO_BASE_URL, NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN } from "./constant";

export const getShoppingProducts: (data) => Promise<any> = async ({
  ageInNumber,
  currentTrimester,
  shoppingWidget,
  pageNo = 1,
  pageSize = 15,
  lat,
  lng,
  CategoryId,
  apolloLogger,
  correlationId,
  pageUrl,
}) => {
  if (!shoppingWidget) {
    return null;
  }

  let body: any = {
    page_id: pageNo,
    size: pageSize,
    lat,
    lng,
  };

  if (currentTrimester) {
    const filteredMaternityCare = shoppingWidget?.MaternityCare.filter(
      (data) => data.Trimester === currentTrimester
    )?.[0];
    const categoryId = CategoryId ? CategoryId : filteredMaternityCare?.CategoryList?.[0]?.CategoryId;
    body = {
      ...body,
      category_id: categoryId,
      filter: {
        [filterKeyForApi["MaternityCare"]]: filteredMaternityCare?.Care ? [filteredMaternityCare?.Care] : [],
      },
    };
  } else if (ageInNumber) {
    const filteredMaternityCare = shoppingWidget?.MaternityCare.filter(
      (data) => data.MonthStart >= ageInNumber && data.MonthEnd <= ageInNumber
    )?.[0];
    const categoryId = CategoryId ? CategoryId : filteredMaternityCare?.CategoryList?.[0]?.CategoryId;
    body = {
      ...body,
      category_id: categoryId,
      filter: {
        [filterKeyForApi["MaternityCare"]]: filteredMaternityCare?.Care ? [filteredMaternityCare?.Care] : [],
      },
    };
  } else if (shoppingWidget?.ProductList) {
    body = {
      ...body,
      skus: shoppingWidget?.ProductList.map((data) => data.ProductId),
    };
  } else {
    const filteredMotherhoodStage = shoppingWidget?.MotherhoodStage?.[0];
    const categoryId = CategoryId ? CategoryId : filteredMotherhoodStage?.CategoryList?.[0]?.CategoryId;
    body = {
      ...body,
      category_id: categoryId,
      filter: {
        [filterKeyForApi["MotherhoodStage"]]: filteredMotherhoodStage?.Stage ? [filteredMotherhoodStage?.Stage] : [],
      },
    };
  }

  return await await fetchUtil({
    url: `${NEXT_PUBLIC_MAGENTO_BASE_URL}/v1/aplCategoryProducts`,
    method: "POST",
    useToken: true,
    token: NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN,
    ctype: "",
    body: body,
    apolloLogger,
    correlationId,
    pageUrl,
  });
};
